/*
* @author  Agence Dn'D <contact@dnd.fr>
* @license https://opensource.org/licenses/osl-3.0.php  Open Software License (OSL 3.0)
* @link    https://www.dnd.fr/
*/

if (!customElements.get('kit-product-item')) {
    class KitProductItem extends HTMLElement {
        connectedCallback() {
            this.variantId = parseInt(this.dataset.variantId);
            this.unitPrice = parseInt(this.dataset.unitPrice);

            const variantsEl = this.querySelector('.js-kit-variants');
            this.variants = variantsEl ? JSON.parse(variantsEl.textContent) : null;

            this.qtyInput = this.querySelector('.kit-qty-input');
            this.totalPriceValue = this.querySelector('.kit-total-price-value');
            this.addToCartBtn = this.querySelector('[data-add-to-cart]');

            this.bindEvents();
        }

        bindEvents() {
            this.querySelectorAll('.js-option').forEach((input) => {
                input.addEventListener('change', () => {
                    this.querySelectorAll('.js-option').forEach((i) => i.removeAttribute('checked'));
                    input.setAttribute('checked', '');
                    this.onVariantChange();
                });
            });

            this.querySelector('.kit-qty-btn--minus')?.addEventListener('click', () => this.updateQty(-1));
            this.querySelector('.kit-qty-btn--plus')?.addEventListener('click', () => this.updateQty(1));
            this.qtyInput?.addEventListener('change', () => this.updateTotalPrice());

            this.addToCartBtn?.addEventListener('click', () => this.addToCart());
        }

        getSelectedOptions() {
            return Array.from(this.querySelectorAll('.option-selector')).map((selector) => {
                const checked = selector.querySelector('.js-option:checked');
                return checked ? checked.value : null;
            });
        }

        onVariantChange() {
            if (!this.variants) return;

            const selectedOptions = this.getSelectedOptions();
            const matched = this.variants.find((v) =>
                v.options.every((opt, i) => opt === selectedOptions[i])
            );

            if (!matched) return;

            this.variantId = matched.id;
            this.unitPrice = matched.price;
            this.addToCartBtn.disabled = !matched.available;

            this.updateTotalPrice();
        }

        updateQty(delta) {
            const next = Math.max(1, (parseInt(this.qtyInput.value) || 1) + delta);
            this.qtyInput.value = next;
            this.updateTotalPrice();
            this.qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        updateTotalPrice() {
            const qty = parseInt(this.qtyInput.value) || 1;
            const total = (this.unitPrice * qty) / 100;
            this.totalPriceValue.textContent = total.toFixed(2);
        }

        async addToCart() {
            const qty = parseInt(this.qtyInput.value) || 1;

            try {
                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: this.variantId, quantity: qty }),
                });

                document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
                document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
                document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
            } catch (err) {
                console.error('Error add to cart kit', err);
            }
        }
    }

    customElements.define('kit-product-item', KitProductItem);
}

document.addEventListener('DOMContentLoaded', () => {
    const addAllBtn = document.querySelector('#add-all-products');
    if (!addAllBtn) return;

    addAllBtn.addEventListener('click', async () => {
        const items = [];

        document.querySelectorAll('kit-product-item').forEach((kitItem) => {
            const variantId = kitItem.variantId;
            const qty = parseInt(kitItem.qtyInput?.value) || 1;
            if (variantId) items.push({ id: variantId, quantity: qty });
        });

        if (!items.length) return;

        try {
            await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items }),
            });

            document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        } catch (err) {
            console.error('Error all add to cart kit', err);
        }
    });
});


// Automatic calculation of the quantity of products in the kit based on the square metres of the selected sheet
const surfaceValueEl = document.querySelector('[data-surface-value]');

if (surfaceValueEl) {
    const updateKitQtiesFromSurface = () => {
        const surfaceValue = parseFloat(document.querySelector('[data-surface-value]')?.textContent.replace(',', '.'));
        if (isNaN(surfaceValue)) return;

        document.querySelectorAll('kit-product-item').forEach((kitItem) => {
            const qtyRatio = parseFloat(kitItem.dataset.qtyRatio);
            if (!qtyRatio) return;

            const qty = Math.ceil(surfaceValue * qtyRatio);
            const qtyInput = kitItem.querySelector('.kit-qty-input');
            if (!qtyInput) return;

            qtyInput.value = qty;
            kitItem.updateTotalPrice();
            qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
    };

    const productForm = document.querySelector('product-form');

    if (productForm) {
        updateKitQtiesFromSurface();

        const observer = new MutationObserver(updateKitQtiesFromSurface);
        observer.observe(productForm, { childList: true, characterData: true, subtree: true });
    }
}

// Automatic calculation of controllers and transformers based on the number of LEDs
document.querySelectorAll('kit-product-item').forEach((kitItem) => {
    if (kitItem.dataset.productType !== 'LED') return;

    const qtyInput = kitItem.querySelector('.kit-qty-input');
    if (!qtyInput) return;

    qtyInput.addEventListener('change', () => {
        const qtyLED = parseInt(qtyInput.value) || 1;
        const qtyControleur = Math.ceil(qtyLED / 4);

        document.querySelectorAll('kit-product-item').forEach((otherItem) => {
            const type = otherItem.dataset.productType;
            if (type !== 'Contrôleur' && type !== 'Transformateur') return;

            const otherQtyInput = otherItem.querySelector('.kit-qty-input');
            if (!otherQtyInput) return;

            otherQtyInput.value = qtyControleur;
            otherItem.updateTotalPrice();
            otherQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
    });
});

// Automatic calculation of remote control based on the number of controllers
document.querySelectorAll('kit-product-item').forEach((kitItem) => {
    if (kitItem.dataset.productType !== 'Contrôleur') return;

    const qtyInput = kitItem.querySelector('.kit-qty-input');
    if (!qtyInput) return;

    qtyInput.addEventListener('change', () => {
        const qtyControleur = parseInt(qtyInput.value) || 1;

        document.querySelectorAll('kit-product-item').forEach((otherItem) => {
            if (otherItem.dataset.productType !== 'Télécommande') return;

            const otherQtyInput = otherItem.querySelector('.kit-qty-input');
            if (!otherQtyInput) return;

            otherQtyInput.value = qtyControleur;
            otherItem.updateTotalPrice();
            otherQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
    });
});
